/**
 * `ingestion` (config-plan §4h, CONFIG CF-13): the ingestion review's settings. One so far:
 *
 *   ingestion.critical_fields   the field keys the review's "missing fields" indicator flags when blank
 *                               (#26, Matt 2026-07-30), until CF-13 the rows of `ingestion_critical_fields`
 *
 * One group named `ingestion`, not a group per setting: the key stays `ingestion.critical_fields` (the plan's
 * key; a group `ingestion.critical_fields` would make it `ingestion.critical_fields.<name>`), and the next
 * review setting with the same gate joins it. A review setting needing another gate gets its own group
 * (`ingestion.<area>`), since the edit key is per group.
 *
 * Who: editPermission feature:settings_reference_data, the gate the Reference Data page (which had the
 * checklist until M286) applies; Admin and Super Admin pass on the server as everywhere. No readPermission:
 * the list is shown only to those who may edit it (Settings → App settings, the one editor since M286). The review
 * reads the set through GET /api/ingestion-critical-fields-routes/custom, open to every signed-in user as
 * before (API getSetting).
 *
 * The value is the set in the order it was saved (the PUT keeps the order it was given, as the table's rows
 * came back in insertion order). The default is the table's seed, in its order: what a database with no row
 * reads, and what production held when CF-13 shipped (CF-13's migration copies the rows in this order).
 * No length cap and no catalog check: the PUT has neither.
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const ingestion = defineGroup('ingestion', {
    label: 'Ingestion review',
    editPermission: 'feature:settings_reference_data',
    settings: {
        critical_fields: {
            type: z
                .array(z.string().trim().min(1))
                .refine((keys) => new Set(keys).size === keys.length, { message: 'each field once' }),
            default: ['property_type_id', 'space_sf', 'land_sf', 'land_ac'],
            label: 'Critical fields',
            help: 'The fields the ingestion review flags when they come back blank (pills at the top of a record and an amber highlight on the field).',
            control: 'field_keys',
        },
    },
});
//# sourceMappingURL=ingestion.js.map